<style scoped>
input {
  border: 1px solid #ced4da;
}

.loader {
  height: 100px;
  width: 100%;
  text-align: center;
  padding: 1em;
  display: inline-block;
  vertical-align: top;
  z-index: 20;
  position: absolute;
  margin: 100px auto;
}

.display-pdfs {
  font-size: 13px;
  padding-left: 3px;
}

.attachment-heading {
  font-weight: bold;
  font-size: 15px;
}

.display-pdfs:not(:first-child) {
  padding-top: 5px;
}

/*
  Set the color of the icon
*/

svg path,
svg rect {
  fill: #0162A7;
}

.add-email-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 11;
  background-color: rgba(255, 255, 255, 0.7);
}

.no-email-message {
  height: 130px;
  width: 400px;
  border: 2px solid #e8ecee;
  border-radius: 5px;
  position: fixed;
  top: 200px;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
<style>
.dropdown-menu {
  top: 0px !important;
  left: 0px !important;
}

#customdropzone {
  min-height: 30px;
  overflow: hidden;
  padding: 0px;
  border: 0px solid grey;
}

#customdrozpne:hover {
  background-color: white;
}

#customdropzone .dz-details {
  background-color: transparent;
  color: black;
  padding: 5px;
  opacity: 1;
}

#customdropzone .dz-preview {
  margin: 0 !important;
  width: 100%;
  display: inline-block;
  min-height: 30px;
  background-color: white !important;
}

#customdropzone .dz-preview .dz-file-preview {
  height: 30px;
}

#customdropzone .dz-preview .dz-progress {
  border-radius: 0;
  margin-left: 0px;
  margin-top: -10px;
  width: 150px;
  position: absolute;
  background-color: white;
  border: 1px solid grey;
}

#customdropzone .dz-remove {
  opacity: 1 !important;
  margin-top: 10px;
  position: absolute;
  right: 50px;
  z-index: 30;
  color: grey;
  border: 0;
  text-decoration: none;
  font-size: .8rem;
  font-weight: 300;
  letter-spacing: 1.1px;
}

.loading {
  opacity: 0.5;
  pointer-events: none;
}

.wrapper {
  position: relative;
}

.vue-tags-input {
  height: auto !important;
  max-width: 100% !important;
}

.ti-input {
  border: 0 !important;
  padding: 0 !important;
}

.remove-attachments {
  cursor: pointer;
  margin-left: 10px;
}
</style>
<script>
import axios from 'axios';
import 'bootstrap-select';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vueDropzone from "vue2-dropzone";
import VueTagsInput, {createTag} from '@johmun/vue-tags-input';

import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/imagetools';
import Editor from '@tinymce/tinymce-vue';
import bootbox from 'bootbox';

export default {
  components: {
    vueDropzone,
    VueTagsInput,
    'editor': Editor
  },
  props: {
    replyTo: {},
    sendTo: {},
    forwardBody: {},
    replyBody: {},
    // Rendered inside the Gmail style "New message" window
    popup: {type: Boolean, default: false}
  },
  data: function () {

    let has_emails = parseInt($('body').attr('data-emails'));

    return {
      separators: [';', ','],
      showBCC: false,
      bcc_toggle_text: 'Show BCC',
      email: {
        sender: '',
        email: '',
        emails: [],
        subject: '',
        message: '',
        cc: '',
        ccs: [],
        bcc: '',
        bccs: [],
        template: '',
        pdfs: [],
        attachments: [],
        replyTo: this.replyTo,
        forwardBody: this.forwardBody
      },
      footer: '',
      signature: '',
      errors: {
        sender: '',
        email: '',
        subject: '',
        message: '',
        cc: '',
        bcc: '',
        template: '',
      },
      dropOptions: {
        url: "/mail",
        thumbnailWidth: 40, // px
        thumbnailHeight: 40,
        addRemoveLinks: false,
        maxFilesize: 25, // MB
        previewTemplate: this.template(),
        autoProcessQueue: false,
        parallelUploads: 10,
        uploadMultiple: true,
      },
      showDropZone: false,
      files: '',
      emails: [],
      has_email: has_emails,
      message: '',
      hide_loading: true,
      hide_submit: true,
      tag: '',
      tags: [],
      templates: [],
      pdf_templates: [],
      editor: null,
      mceEditor: {
        // Focus the editor when opened as a reply/forward (the "tiny-compose" id it used to target no longer exists)
        auto_focus: !!(this.replyBody || this.forwardBody),
        skin_url: "/tinymce/skins/ui/oxide",
        content_css: "/tinymce/skins/ui/oxide/content.min.css",
        language: $('meta[name="language"]').attr('content'),
        language_url: `/tinymce/langs/${$('meta[name="language"]').attr('content')}.js`,
        branding: false,
        height: this.popup ? 300 : 500,
        menubar: this.popup ? false : 'edit insert view format table tools help',
        statusbar: !this.popup,
        resize: !this.popup,
        toolbar_location: this.popup ? 'bottom' : 'auto',
        relative_urls: false,
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
          return url;
        },
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste",
          "image imagetools"
        ],
        toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | ChooseTemplate | AttachFiles | AttachPDFs`,
        image_list: "/template/images/logos",
        setup: (editor) => {
          this.editor = editor;

          editor.ui.registry.addButton('ChooseTemplate', {
            text: this.$t('choose_template'),
            onAction: () => {
              let templates = [{'text': this.$t('select_template'), value: ''}];
              this.templates.map((item) => {
                templates.push({
                  text: item.name,
                  value: item.id
                });
              });
              bootbox.prompt({
                title: this.$t('select_an_email_template'),
                buttons: {
                  confirm: {
                    label: this.$t('save'),
                  },
                  cancel: {
                    label: this.$t('cancel'),
                  }
                },
                inputType: 'select',
                inputOptions: templates,
                value: "",
                centerVertical: true,
                callback: (result) => {
                  if (result) {
                    let id = result;
                    if (id.length) {
                      this.email.template = id;
                      $.ajax({
                        type: 'GET',
                        url: '/template/content',
                        data: {
                          id,
                          button: this.button_id
                        },
                        success: (res) => {
                          if (res) {
                            this.email.message = res.content;

                            this.email.message += '<br>'
                            this.email.message += this.signature;
                            this.email.message += this.footer;

                            if (res.subject && res.subject.length) {
                              this.email.subject = res.subject;
                            } else {
                              this.email.subject = "";
                            }

                            if (res.pdfs && res.pdfs.length) {
                              this.email.pdfs = res.pdfs.map(function (x) {
                                return parseInt(x, 10);
                              });
                            } else {
                              this.email.pdfs = [];
                            }

                            if (res.attachments && res.attachments.length) {
                              this.email.attachments = res.attachments;
                            } else {
                              this.email.attachments = [];
                            }
                          }
                        }
                      });
                    }
                  }
                }
              });
            }
          });

          editor.ui.registry.addButton('AttachFiles', {
            text: this.$t('attach_files'),
            onAction: () => {
              $('#customdropzone').click();
            }
          });
        }
      },
      button_id: '',
      record_id: '',
      table_id: '',
      autocomplete_to_emails: [],
      autocomplete_cc_emails: [],
      autocomplete_bcc_emails: [],
      debounce: null,
    }
  },
  watch: {
    'email.email': 'initToAutoComplete',
    'email.cc': 'initCCAutoComplete',
    'email.bcc': 'initBCCAutoComplete',
  },
  mounted: function () {
    this.email.sender = $('#webmail').attr('data-account-id');

    axios.get('/user/emails')
        .then(res => {
          this.emails = res.data;
          let sender = parseInt(this.email.sender);
          if (this.emails.length && !this.emails.some(e => e.id === sender)) {
            this.email.sender = this.emails[0].id;
          } else {
            this.email.sender = sender;
          }
        });
    if (this.sendTo.length) {
      this.sendTo.forEach(email => {
        let tag = createTag(email, [email]);
        this.$refs.to_tag.addTag(tag);
      });
    }

    axios.get('/settings/users/signatures')
        .then(res => {
          this.footer = res.data.footer;
          this.signature = res.data.email;
          this.email.message = '<br>'
          this.email.message += this.signature;
          this.email.message += this.footer;

          if (this.forwardBody.length) {
            this.email.message = this.forwardBody;
          }

          if (this.replyBody.length) {
            this.email.message = this.replyBody;
          }
        }).catch((err) => {
      // console.log(err);
    });

    this.showDropZone = this.$refs.dropzone.getQueuedFiles().length > 0;

    let table_id = this.getTableID();

    if (table_id) {
      this.getTableTemplates(table_id);
    } else {
      this.getAllTemplates();
    }

    $('.send-email').on('click', this.initEmailModal);
    this.$emit('showSend', true);
  },

  beforeDestroy: function () {
    this.$emit('showSend', false);
  },

  updated() {
    $(this.$refs.pdf_templates).selectpicker({
      container: 'body'
    }).selectpicker('refresh');
  },

  methods: {
    updateRecipients(recipients) {
      this.email.emails = [];
      recipients.forEach(email => {
        let tag = createTag(email, [email]);
        this.$refs.to_tag.addTag(tag);
      });
    },

    updateCCs(recipients) {
      this.email.ccs = [];
      recipients.forEach(email => {
        let tag = createTag(email, [email]);
        this.$refs.cc_tag.addTag(tag);
      });
    },

    setupForwardEmail(content) {
      // On first open the editor is still initializing; the content then comes from the forwardBody prop
      if (this.editor) {
        this.editor.setContent(content);
      }
    },

    setupReplyEmail(content) {
      // On first open the editor is still initializing; the content then comes from the replyBody prop
      if (this.editor) {
        this.editor.setContent(content);
      }
    },

    setReplyTo(message_id) {
      this.email.replyTo = message_id;
    },

    setSubject(subject) {
      this.email.subject = subject;
    },

    getAllTemplates() {
      $.ajax({
        type: 'GET',
        url: '/email/templates',
        success: (res) => {
          if (res.email.length) {
            this.templates = res.email;
          }
        }
      });
    },

    getTableTemplates(table_id) {
      $.ajax({
        type: 'GET',
        url: '/email/templates',
        data: {
          table_id
        },
        success: (res) => {
          if (res.email.length) {
            this.templates = res.email;
          }

          if (res.pdf.length) {
            this.pdf_templates = res.pdf;
          }
        }
      });
    },

    initEmailModal(e) {
      let $target = $(e.target).hasClass('far') ? $(e.target).parents('.nav-action-btn') : $(e.target);
      let payload = JSON.parse($target.attr('data-email-payload'));
      this.button_id = $target.attr('data-id');
      this.record_id = $target.attr('data-record-id');
      this.table_id = $target.attr('data-table-id');

      this.email.emails = payload.email.map((item) => {
        return {
          text: item
        }
      });

      this.email.bccs = payload.bcc.map((item) => {
        return {
          text: item
        }
      });

      this.email.ccs = payload.cc.map((item) => {
        return {
          text: item
        }
      });

      this.email.subject = payload.subject ? payload.subject : '';

      this.email.message = payload.message ? payload.message : '';

      this.email.pdfs = payload.pdfs.map(pdf => {
        return parseInt(pdf);
      });

      this.email.template = payload.template ? parseInt(payload.template) : '';

      this.email.attachments = payload.attachments;

      this.hide_submit = true;

      this.email.message += '<br>'
      this.email.message += this.signature;
      this.email.message += this.footer;
    },

    template: function () {
      return `<div class="dz-preview dz-file-preview">
                            <div class="dz-details">
                                <div>
                                    <div class="upload-details">
                                        <b><span data-dz-name></span></b>

                                        (<span data-dz-size></span>)

                                        <i class="fa fa-times remove-attachments" data-dz-remove></i>
                                    </div>

                                    <div class="upload-progress">
                                        <span class="dz-progress">
                                            <span class="dz-upload" data-dz-uploadprogress></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dz-error-message"><span data-dz-errormessage></span></div>
                            <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                            <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                        </div>`;
    },

    clearErrors() {
      this.errors = {
        sender: '',
        email: '',
        subject: '',
        message: '',
        cc: '',
        bcc: '',
        template: ''
      };
    },

    clearEmailForm() {
      this.email = {
        sender: this.email.sender,
        email: '',
        emails: [],
        subject: '',
        message: '',
        cc: '',
        ccs: [],
        bcc: '',
        bccs: [],
        template: '',
        pdfs: [],
        attachments: [],
        replyTo: this.replyTo,
      };

      this.files = '';
      this.message = '';

      this.email.message = '<br>'
      this.email.message += this.signature;
      this.email.message += this.footer;
    },

    getEmailsFromTagsInput(emails) {
      let input = [];
      $(emails).each(function (i, email) {
        input.push(email.text);
      });
      return input.join(',');
    },

    getTableID() {
      let table_id = this.getUrlParameter('table_id'),
          $init_email = $('.table-button-holder'),
          $browse_table = $(".browse-table");

      if ($init_email.length) {
        table_id = $init_email.attr('data-table-id');
      } else if ($browse_table.length) {
        table_id = $browse_table.attr('data-table-id');
      }
      return table_id;
    },

    getRecordID() {
      let record = this.getUrlParameter('record'),
          $init_email = $('.table-button-holder');

      if ($init_email.length) {
        record = $init_email.attr('data-record-id');
      }
      return record;
    },

    handleEmailSubmit(e) {
      e.preventDefault();
      this.clearErrors();
      this.message = '';
      this.hide_loading = false;

      $(':focus').blur();

      setTimeout(() => {
        let formData = new FormData();
        formData.append('email', this.getEmailsFromTagsInput(this.email.emails));
        formData.append('cc', this.getEmailsFromTagsInput(this.email.ccs));
        formData.append('bcc', this.getEmailsFromTagsInput(this.email.bccs));

        formData.append('subject', this.email.subject ? this.email.subject : '');
        formData.append('message', this.email.message ? this.email.message : '');
        formData.append('sender', this.email.sender ? this.email.sender : '');
        formData.append('table_id', this.table_id);
        formData.append('record', this.record_id);
        formData.append('template', this.email.template);
        formData.append('pdfs', this.email.pdfs);
        formData.append('replyTo', this.email.replyTo);
        formData.append('attachments', this.email.attachments);

        if (!this.$refs.dropzone.getQueuedFiles().length) {

          formData.append('action', 'send');

          axios.post('/mail',
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          ).then(sent => {
            if (sent) {

              let $step = $(`.wizard-section .step[data-action="create-quotation"]`);
              $step.addClass('done');
              this.clearEmailForm();
              this.hide_loading = true;
              $('#mail-modal').modal('hide');
              this.$emit('sent');
              toastr.success(this.$t('email_sent'))
            }
          }).catch((err) => {
            let errors = err.response.data.errors;
            Object.keys(errors).forEach((key) => {
              if (key === 'smpt_failed') {
                toastr.error(errors[key][0]);
              }
              this.errors[key] = errors[key][0];
            });
            this.hide_loading = true;
          });
        } else {
          formData.append('action', 'validate');
          axios.post('/mail',
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          ).then(validated => {
            if (validated) {
              this.$refs.dropzone.processQueue();
            }
          }).catch((err) => {
            let errors = err.response.data.errors;
            Object.keys(errors).forEach((key) => {
              if (key === 'smpt_failed') {
                toastr.error(errors[key][0]);
              }
              this.errors[key] = errors[key][0];
            });
            this.hide_loading = true;
          });
        }
      }, 300);
    },

    attachFiles(e) {
      e.preventDefault();
      $('#customdropzone').click();
    },

    handleFileUploads() {
      this.files = this.$refs.files.files;
    },

    fileAdded(file) {
      this.showDropZone = true;
    },

    sendingEvent(file, xhr, formData) {
      formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
      formData.append('action', 'send');
      formData.append('subject', this.email.subject ? this.email.subject : '');
      formData.append('message', this.email.message ? this.email.message : '');
      formData.append('sender', this.email.sender ? this.email.sender : '');
      formData.append('email', this.getEmailsFromTagsInput(this.email.emails));
      formData.append('cc', this.getEmailsFromTagsInput(this.email.ccs));
      formData.append('bcc', this.getEmailsFromTagsInput(this.email.bccs));
      formData.append('table_id', this.table_id);
      formData.append('record', this.record_id);
      formData.append('template', this.email.template);
      formData.append('pdfs', this.email.pdfs);
      formData.append('replyTo', this.email.replyTo);
      formData.append('attachments', this.email.attachments);
    },

    mailSent(response) {
      if (response) {
        this.clearEmailForm();
        this.showDropZone = false;
        this.$refs.dropzone.removeAllFiles();
        this.hide_loading = true;
        $('#mail-modal').modal('hide');
      }
    },

    getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
          results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    preventTinyMCESubmit(e, editor) {
      e.preventDefault();
    },

    closeTemplateModal(e) {
      e.preventDefault();
      $('#select-pdf-modal').modal('hide');
    },

    closeComposeEmailModal(e) {
      $('#cancel-email').trigger('click');
    },

    removeAttachment(path) {
      this.email.attachments = this.email.attachments.filter(item => item !== path);
    },

    fileRemoved(file, error, xhr) {
      if (!this.$refs.dropzone.getQueuedFiles().length) {
        this.showDropZone = false;
      }
    },

    removePDF(id) {
      this.email.pdfs = this.email.pdfs.filter(item => item !== id);
    },

    toggleBCCField(e) {
      e.preventDefault();

      if (this.showBCC) {
        this.showBCC = false;
        this.bcc_toggle_text = 'Show BCC';
      } else {
        this.showBCC = true;
        this.bcc_toggle_text = 'Hide BCC';
      }
    },

    initToAutoComplete() {
      if (this.email.email.length < 2) return;
      const url = `/mail/autocomplete?search=${this.email.email}`;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios.get(url).then(response => {
          this.autocomplete_to_emails = response.data.map(email => {
            return {text: email};
          });
        }).catch(() => console.warn('Oh. Something went wrong'));
      }, 600);
    },

    initCCAutoComplete() {
      if (this.email.cc.length < 2) return;
      const url = `/mail/autocomplete?search=${this.email.cc}`;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios.get(url).then(response => {
          this.autocomplete_cc_emails = response.data.map(email => {
            return {text: email};
          });
        }).catch(() => console.warn('Oh. Something went wrong'));
      }, 600);
    },

    initBCCAutoComplete() {
      if (this.email.bcc.length < 2) return;
      const url = `/mail/autocomplete?search=${this.email.bcc}`;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios.get(url).then(response => {
          this.autocomplete_bcc_emails = response.data.map(email => {
            return {text: email};
          });
        }).catch(() => console.warn('Oh. Something went wrong'));
      }, 600);
    },

    checkTag(obj) {
      var input = obj.tag.text;
      if (this.validateEmail(input)) {
        obj.addTag();
      } else {
        const url = `/mail/autocomplete/validate?search=${input}`;
        axios.get(url).then(response => {
          obj.tag.text = response.data;
          obj.addTag();
        }).catch(() => console.warn('Oh. Something went wrong'));
      }
    },

    validateEmail(email) {
      return String(email)
          .toLowerCase()
          .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }
  }
}
</script>
<template>
  <div class="wrapper" :class="{'compose-popup': popup}">
    <div v-show="!has_email" class="add-email-overlay">
      <div class="no-email-message text-center">
        <p class="mt-3">
          <b>{{ $t('no_email') }}</b>
        </p>

        <div class="text-center">
          <a href="/emails">
            <button class="btn btn-dark">
              {{ $t('add_email') }}
            </button>
          </a>

          <button class="btn btn-secondary apply-btn-color" @click="closeComposeEmailModal">
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'd-none' : hide_loading }" class="loader">
      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px"
           width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                  <path fill="#000"
                        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                      <animateTransform attributeType="xml"
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 25 25"
                                        to="360 25 25"
                                        dur="0.6s"
                                        repeatCount="indefinite"/>
                  </path>
              </svg>
    </div>
    <form @submit="handleEmailSubmit" enctype="multipart/form-data">

      <div class="form-group row">
        <label class="col-sm-1 pt-2">{{ $t('from') }}</label>

        <div class="col-sm-11">
          <select class="form-control" v-model="email.sender">
            <option v-for="l in emails" :value="l.id">{{ l.email }}</option>
          </select>
          <small v-if="errors.sender.length" class="form-text text-danger">{{ errors.sender }}</small>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-1 pt-2">{{ $t('to') }}</label>
        <div class="col-sm-11">
          <vue-tags-input
              v-model="email.email"
              :tags="email.emails"
              class="form-control pl-0"
              ref="to_tag"
              placeholder=""
              @tags-changed="newTags => email.emails = newTags"
              :autocomplete-items="autocomplete_to_emails"
              :addOnKey="[13, 188]"
              :allowEditTags="true"
              @before-adding-tag="checkTag"
          />
          <small v-if="errors.email.length" class="form-text text-danger">{{ errors.email }}</small>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-1 pt-2">CC</label>
        <div class="col-sm-11">

          <div class="input-group mb-3">
            <vue-tags-input
                v-model="email.cc"
                :tags="email.ccs"
                class="form-control pl-0"
                ref="cc_tag"
                placeholder=""
                @tags-changed="newTags => email.ccs = newTags"
                :autocomplete-items="autocomplete_cc_emails"
                :addOnKey="[13, 188]"
                :allowEditTags="true"
                @before-adding-tag="checkTag"
            />
            <div class="input-group-append">
              <button class="btn" type="button" @click="toggleBCCField($event)"
                      :class="popup ? 'compose-bcc-toggle' : 'btn-primary apply-btn-color'">
                {{ popup ? 'Bcc' : bcc_toggle_text }}
              </button>
            </div>
            <small v-if="errors.cc.length" class="form-text text-danger">{{ errors.cc }}</small>
          </div>
        </div>
      </div>

      <div class="form-group row" v-bind:class="{'d-none' : !showBCC}">
        <label class="col-sm-1 pt-2">BCC</label>
        <div class="col-sm-11">
          <vue-tags-input
              v-model="email.bcc"
              :tags="email.bccs"
              class="form-control pl-0"
              placeholder=""
              @tags-changed="newTags => email.bccs = newTags"
              :autocomplete-items="autocomplete_bcc_emails"
              :addOnKey="[13, 188]"
              :allowEditTags="true"
              @before-adding-tag="checkTag"
          />
          <small v-if="errors.bcc.length" class="form-text text-danger">{{ errors.bcc }}</small>
        </div>
      </div>

      <div class="form-group row" v-if="!email.replyTo.length">
        <label v-if="!popup" class="col-sm-1 pt-2">{{ $t('subject') }}</label>
        <div class="col-sm-11">
          <input v-model="email.subject" type="text" class="form-control" :placeholder="popup ? $t('subject') : ''">
          <small v-if="errors.subject.length" class="form-text text-danger">{{ errors.subject }}</small>
        </div>
      </div>

      <div class="form-group compose-editor">
        <editor
            api-key="no-api-key"
            class="tiny-compose"
            :init="mceEditor"
            v-model="email.message"
            @onSubmit="preventTinyMCESubmit"
            ref="tinyeditor"
        ></editor>
        <small v-if="errors.message.length" class="form-text text-danger">{{ errors.message }}</small>
      </div>

      <div class="form-group compose-attachments">
        <div v-show="showDropZone || email.attachments.length">
          <div class="attachment-heading">
            {{ $t('email_attachments') }}
          </div>
        </div>

        <vue-dropzone
            v-show="showDropZone"
            id="customdropzone"
            ref="dropzone"
            :options="dropOptions"
            @vdropzone-file-added="fileAdded"
            @vdropzone-sending="sendingEvent"
            @vdropzone-success-multiple="mailSent"
            @vdropzone-removed-file="fileRemoved"
        ></vue-dropzone>

        <div v-for="path in email.attachments" class="display-pdfs" style="padding-left: 5px;">
          <b>
            {{ path.replace(/^.*[\\\/]/, '') }} <i class="fa fa-times remove-attachments"
                                                   @click="removeAttachment(path)"></i>
          </b>
        </div>

        <div class="pt-2">
          <div class="attachment-heading" v-show="email.pdfs.length">
            {{ $t('pdf_attachments') }}
          </div>

          <div v-for="l in pdf_templates" class="display-pdfs" v-show="email.pdfs.includes(l.id)">
            {{ l.name }} <i class="fa fa-times remove-attachments" @click="removePDF(l.id)"></i>
          </div>
        </div>
      </div>

      <div class="form-group compose-submit">
        <button type="submit" id="submit-email-modal"
                class="d-none btn btn-primary apply-btn-color pull-right send-email-btn">{{ $t('send') }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="select-pdf-modal" tabindex="-2" role="dialog" aria-labelledby="select-pdf-modal"
           aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-scrollable modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="select-pdf-title">
                {{ $t('select_pdfs') }}
              </h5>
            </div>
            <div class="modal-body" id="select-pdf-body">
              <select data-style="btn-secondary"
                      class="form-control selectpicker"
                      ref="pdf_templates" v-model="email.pdfs"
                      multiple>
                <option v-for="l in pdf_templates" :value="l.id">{{ l.name }}</option>
              </select>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary apply-btn-color" id="select-pdf-email"
                      @click="closeTemplateModal">
                {{ $t('close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-if="message.length" class="alert alert-success">{{ message }}</div>
  </div>
</template>